
export enum CameraDiagnosticRecordType {
    Gps,
    Trip,
    Video
}
